/**
 * Client-side logger for browser environments
 * Uses console methods but with structured context
 */

type LogLevel = 'debug' | 'info' | 'warn' | 'error'

interface LogContext {
  [key: string]: unknown
}

class ClientLogger {
  constructor(private component: string) {}

  private log(level: LogLevel, message: string, context?: LogContext): void {
    if (typeof window === 'undefined') return

    switch (level) {
      case 'debug':
        console.debug(`[${this.component}]`, message, context || '')
        break
      case 'info':
        console.info(`[${this.component}]`, message, context || '')
        break
      case 'warn':
        console.warn(`[${this.component}]`, message, context || '')
        break
      case 'error':
        console.error(`[${this.component}]`, message, context || '')
        break
    }
  }

  debug(message: string, context?: LogContext): void {
    this.log('debug', message, context)
  }

  info(message: string, context?: LogContext): void {
    this.log('info', message, context)
  }

  warn(message: string, context?: LogContext): void {
    this.log('warn', message, context)
  }

  error(message: string, context?: LogContext): void {
    this.log('error', message, context)
  }
}

export function createClientLogger(component: string): ClientLogger {
  return new ClientLogger(component)
}
